var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":_vm.bgcolor}},[_vm._t("icon",function(){return [_c('v-icon',{attrs:{"color":_vm.color || 'black'},on:{"click":function($event){_vm.routename
          ? _vm.$router.go(-1)
          : _vm.customRoute
          ? _vm.$router.push(_vm.customRoute).catch(function () {})
          : _vm.emitforclose()}}},[_vm._v(" mdi-arrow-left ")])]}),_c('v-spacer'),_c('span',{staticClass:"text-md-body-1 font-weight-6"},[_vm._v(_vm._s(_vm.title))]),_c('v-spacer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }